
import {of as observableOf, timer as observableTimer,  Observable } from 'rxjs';

import {map} from 'rxjs/operators';
import { AbstractControl, ValidationErrors } from "@angular/forms";

//below regex was taken from top answer in https://stackoverflow.com/questions/46370725/how-to-do-email-validation-using-regular-expression-in-typescript
const EMAIL_REGEXP = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

export function isValidEmail(control: AbstractControl): Observable<ValidationErrors|null> | null {
    const value = control && control.value;
    if (value && !EMAIL_REGEXP.test(value)) {
        return observableTimer(500).pipe(map(() => ({
                email: true
        })));
    }

    return observableOf({});
}